import React from 'react';
import {
  BetStatus,
  convertAmount,
  exchangeAmountByRate,
  ListElemText,
  ListItem,
  ListItemCell,
  ListItemCont,
  maskName,
  parseNumberByPrecision,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { globalTranslationKeys } from '../../../enums';

export const OtherBetItem = observer(({ data: bet }) => {
  const t = useTranslation();
  const { precision } = userInfoStore;

  return (
    <ListItemCont forRemove={bet.isFinished} animationDelayInSeconds={1.5}>
      <ListItem active={bet.winAmount}>
        <ListItemCell>
          <ListElemText>{maskName(bet.playerExternalId)}</ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {bet.freeBetId
              ? t(globalTranslationKeys.FreeBets)
              : convertAmount(exchangeAmountByRate(bet).amount)}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText className='to-lowercase'>
            {bet.status === BetStatus.Pending && !bet.winAmount
              ? '- -'
              : `x${parseNumberByPrecision(bet.odd, 1, precision)}`}
          </ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText>
            {bet.status === BetStatus.Pending && !bet.winAmount
              ? '...'
              : convertAmount(exchangeAmountByRate(bet).winAmount)}
          </ListElemText>
        </ListItemCell>
      </ListItem>
    </ListItemCont>
  );
});
